import styled from 'styled-components';

const Wrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  background: white;
  color: black;
  border-radius: 3px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
`;

export default { Wrapper };
